const styles = ({ COLORS }) => ({
  container: {
    display: 'flex',
    alignItems: 'flex-start'
  },
  action: {
    color: '#a8a8a8'
  },
  name: {
    color: '#666'
  },
  avatar: {
    borderRadius: '100%',
    width: '25px',
    height: '25px',
    marginRight: '8px',
    fontSize: '25px',
    flexShrink: 0
  },
  content: {
    paddingTop: '4px',
    width: '100%',
    '& p': {
      marginBottom: 0
    }
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '20px'
  },
  button: {
    background: 'rgba(0,0,0,0.04)',
    color: '#505050',
    fontWeight: 'normal',
    borderColor: 'transparent',
    fontSize: '12px',
    padding: '4px 8px',
    height: 'auto',
    marginLeft: '4px',
    '&:hover': {
      color: '#fff'
    },
    '&:disabled': {
      color: 'rgba(1,1,1,0.2)'
    }
  },
  markedAsConclusion: {
    fontWeight: 'bold',
    marginBottom: '20px',
    '& span': {
      fontWeight: 'normal'
    }
  },
  wrapper: {
    transition: 'background 300ms ease-in-out, outline 300ms ease-in-out',
    outline: '14px solid transparent',
    margin: '34px 0 14px'
  },
  conclusion: {
    background: '#ebf9fe',
    outlineColor: '#ebf9fe'
  },
  attachment: {
    display: 'block',
    border: '1px solid #e5e5e5',
    padding: '5px',
    marginTop: '20px',
    textDecoration: 'none',
    color: '#5c5c5c',
    borderRadius: '4px',
    '&:hover': {
      color: COLORS.BLUE.NORMAL
    }
  },
  dots: {
    float: 'right',
    '& > button': {
      height: '20px',
      width: '20px',
      padding: '4px',
      border: 'none'
    }
  },
  link: {
    color: COLORS.BLUE.NORMAL,
    fontWeight: 'bold',
    textDecoration: 'none'
  },
  ref: {
    marginTop: '10px'
  },
  replies: {
    borderLeft: '1px solid #e5e5e5',
    paddingLeft: '20px',
    marginTop: '10px'
  },
  replyActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%'
  },
  replyForm: {
    padding: '10px',
    background: '#fafafa',
    borderBottom: '2px solid #eee'
  },
  conclusionContent: {
    textAlign: 'center',
    '& p': {
      fontSize: '18px',
      lineHeight: '24px'
    },
    '& h3': {
      marginBottom: 0
    },
    '& img': {
      maxWidth: '200px',
      marginTop: '38px'
    }
  },
  conclusionFooter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  check: {
    background: COLORS.BLUE.NORMAL,
    color: '#fff',
    padding: '2px',
    borderRadius: '100%',
    position: 'relative',
    top: '-1px'
  }
})

export default styles
